import React from "react";
import { Container, makeStyles, Typography } from "@material-ui/core";
import { blueColor } from "../../hoc/Layout/theme";
import packageInfo from "../../../package.json";

const useStyles = makeStyles((theme) => ({
  main: {
    marginTop: theme.spacing(8),
    marginBottom: theme.spacing(2),
  },
  footer: {
    padding: theme.spacing(2),
    marginTop: "auto",
    backgroundColor: theme.palette.grey,
  },
}));

function Copyright() {
  return (
    <Typography
      variant="body2"
      color="textSecondary"
      align="center"
      style={{ direction: "ltr" }}
    >
      {"Copyright © "}
      <a color="inherit" href="#">
        Portal
      </a>{" "}
      {new Date().getFullYear()}
      {"-"} {packageInfo.version}
    </Typography>
  );
}

const Footer = (props) => {
  const classes = useStyles();

  return (
    <footer className={classes.footer}>
      <Container maxWidth="lg">
        <Typography variant="body2" align={"center"}>
          تمام حقوق مادی و معنوی متعلق به
          <strong style={{ paddingLeft: 5, paddingRight: 5, color: blueColor }}>
            {" "}
            سیستم مدیریت چک{" "}
          </strong>
          می باشد.
        </Typography>
        <Copyright />
      </Container>
    </footer>
  );
};

export default Footer;
